import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

export const CANVAS_VIEW_BETA_DOCS = `${SKETCH_WEBSITE}/docs/canvas-view-beta`

export const CANVAS_VIEW_FEEDBACK = `${SKETCH_WEBSITE}/support/contact/beta`
